import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalAppCallServiceRequest } from '../../models/rest/app/local-app-call-service-request';
import { Observable, catchError, map, of, throwError as observableThrowError, throwError } from 'rxjs';
import { LocalAppCallServiceResponse } from '../../models/rest/app/local-app-call-service-response';
import { ExecuteAppResponse } from '../../models/rest/app/execute-app-response';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class LocalAppService {

  constructor(private http: HttpClient) { }

  callLocalApp(request: LocalAppCallServiceRequest): Observable<LocalAppCallServiceResponse> {

    const url = `${environment.printerUrl}/v1/proxy`;
    return this.http.post<LocalAppCallServiceResponse>(url, request).pipe(
      catchError(this.errorHandler)
    );
  }


  getLocalAppIsAlive(): Observable<boolean> {
    const url = `${environment.printerUrl}/v1/printer/is-alive`;
    return this.http.get(url).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  openWhatsAppDesktop(phone: string, message: string): Observable<ExecuteAppResponse> {
    const request = {
      phone: phone,
      message: message || ''
    };
    const url = `${environment.printerUrl}/v1/whatsapp/open`;
    return this.http.post<ExecuteAppResponse>(url, request).pipe(
      catchError(this.errorHandler)
    );
  }

  post(url: string, data: string, headers: { [key: string]: string } = {}, timeout?: number): Observable<LocalAppCallServiceResponse> {
    const request = new LocalAppCallServiceRequest(url, 'POST', headers, data, timeout);
    return this.callLocalApp(request);
  }

  private errorHandler(error: any): Observable<never> {
    console.error('Error:', error);

    const errorMessage = error?.message || error;
    if (
      errorMessage === 'Http failure response' ||
      errorMessage.includes('Unknown Error')
    ) {
      return throwError(() => new Error('Lokal uygulama servislerine erişim yok'));
    }
    return throwError(() => new Error(error));
  }
}
